import { getDeviceInfo } from './device';
import { getLxCuid } from '@/utils/userInfo';


export const OwlService = {
  // raptor大盘业务失败埋点
  addFailurePoint(name, data?) {
    addAjaxError(name, { tags: data });
  },
};

/**
 * @description:  手动上报接口异常
 * @param {*} options
 * 方法文档:https://km.sankuai.com/collabpage/253147798#id-%E6%89%8B%E5%8A%A8%E4%B8%8A%E6%8A%A5%E5%BC%82%E5%B8%B8%E4%BF%A1%E6%81%AF
 * @return {*}
 */
export function addAjaxError(err: string | Object | Error, options?: { tags: Object }) {
  const { tags = {} } = options || {};
  const { platform, platformVersion } = getDeviceInfo() || {};

  window.owl?.('addError', err, {
    level: 'warn',
    category: 'ajaxError',
    tags: {
      ...tags,
      platform,
      platformVersion,
      lxCuid: getLxCuid(),
    },
  });
}

export function addJsError(err: string | Error, options?: { tags: Object }) {
  const { tags = {} } = options || {};
  window.owl?.('addError', err, {
    level: 'error',
    category: 'jsError',
    tags: {
      ...tags,
      lxCuid: getLxCuid(),
    },
  });
}
